import * as React from "react";
const IconLicenseCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M17.4 34.5c3.2 0 5.9-2.6 5.9-5.9s-2.6-5.9-5.9-5.9-5.9 2.6-5.9 5.9 2.7 5.9 5.9 5.9m0-9.7c2.1 0 3.9 1.7 3.9 3.9s-1.7 3.9-3.9 3.9-3.9-1.7-3.9-3.9 1.8-3.9 3.9-3.9M49 42.3H13.7c-.6 0-1 .4-1 1s.4 1 1 1H49c.6 0 1-.4 1-1s-.4-1-1-1M49 22.8h-9.7c-.6 0-1 .4-1 1s.4 1 1 1H49c.6 0 1-.4 1-1s-.4-1-1-1M49 32.5h-9.7c-.6 0-1 .4-1 1s.4 1 1 1H49c.6 0 1-.4 1-1 0-.5-.4-1-1-1" />
    <path d="M57 11.6H7c-2.8 0-5 2.2-5 5v30.8c0 2.8 2.2 5 5 5h50c2.8 0 5-2.2 5-5V16.6c0-2.8-2.2-5-5-5m3 35.8c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V16.6c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3z" />
  </svg>
);
export default IconLicenseCopy;
